// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.box[data-v-f86cd63c] {\n\tpadding: 5px;\n\tborder-radius: 2px;\n\tfont-size: 13px;\n}\n.warning-1-color[data-v-f86cd63c] {\n\tbackground: gray;\n\tcolor: white;\n}\n.warning-2-color[data-v-f86cd63c] {\n\tbackground: #85cdd9;\n\tcolor: #237853;\n}\n.warning-3-color[data-v-f86cd63c] {\n\tbackground: #ed823d;\n\tcolor: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
